import { AssistanceEvent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/AssistanceType";
import { FC } from "react";

type ExpandableBodyProps = {
  assistanceEvent: AssistanceEvent;
};

export const ExpandableBodyContent: FC<ExpandableBodyProps> = ({
  assistanceEvent,
}) => {
  const distribution =
    assistanceEvent.distributions.find((d) => d.contextName === "DROPS") ??
    assistanceEvent.distributions.at(0);
  return (
    <div style={{ gridColumn: "1 / -1" }}>
      {distribution?.text.message || "Mangler beskrivelse"}
    </div>
  );
};
